/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * MARKETview API
 * OpenAPI spec version: 0.0.1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ClientReportDto,
  ClientReportRequest,
  GetClientReportsParams
} from '../schemas';

import { customAxios } from '../../orval-mutator';
import type { ErrorType , BodyType } from '../../orval-mutator';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * Authorities: **ROLE_SUPER_ADMIN, ROLE_REPORT_ADMIN**<br /><br />Edit client report
 */
export const editClientReport = (
    userId: string,
    clientId: number,
    reportId: number,
    clientReportRequest: BodyType<ClientReportRequest>,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<ClientReportDto>(
      {url: `/api/${userId}/clients/${clientId}/reports/${reportId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: clientReportRequest, signal
    },
      options);
    }



export const getEditClientReportMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof editClientReport>>, TError,{userId: string;clientId: number;reportId: number;data: BodyType<ClientReportRequest>}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof editClientReport>>, TError,{userId: string;clientId: number;reportId: number;data: BodyType<ClientReportRequest>}, TContext> => {

const mutationKey = ['editClientReport'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof editClientReport>>, {userId: string;clientId: number;reportId: number;data: BodyType<ClientReportRequest>}> = (props) => {
          const {userId,clientId,reportId,data} = props ?? {};

          return  editClientReport(userId,clientId,reportId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type EditClientReportMutationResult = NonNullable<Awaited<ReturnType<typeof editClientReport>>>
    export type EditClientReportMutationBody = BodyType<ClientReportRequest>
    export type EditClientReportMutationError = ErrorType<unknown>

    export const useEditClientReport = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof editClientReport>>, TError,{userId: string;clientId: number;reportId: number;data: BodyType<ClientReportRequest>}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof editClientReport>>,
        TError,
        {userId: string;clientId: number;reportId: number;data: BodyType<ClientReportRequest>},
        TContext
      > => {
      return useMutation(getEditClientReportMutationOptions(options), queryClient);
    }
    /**
 * Authorities: **ROLE_SUPER_ADMIN, ROLE_FD_PRINCIPAL, ROLE_FD_CLIENT_SERVICE, ROLE_FD_ANALYST, ROLE_REPORT_ADMIN**<br /><br />Only equals filter is allowed for productId
 * @summary Get client product reports
 */
export const getClientReports = (
    userId: string,
    clientId: number,
    params?: GetClientReportsParams,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<ClientReportDto[]>(
      {url: `/api/${userId}/clients/${clientId}/reports`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetClientReportsQueryKey = (userId: string,
    clientId: number,
    params?: GetClientReportsParams,) => {
    return [
    `/api/${userId}/clients/${clientId}/reports`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetClientReportsQueryOptions = <TData = Awaited<ReturnType<typeof getClientReports>>, TError = ErrorType<unknown>>(userId: string,
    clientId: number,
    params?: GetClientReportsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getClientReports>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetClientReportsQueryKey(userId,clientId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getClientReports>>> = ({ signal }) => getClientReports(userId,clientId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: !!(userId && clientId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getClientReports>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetClientReportsQueryResult = NonNullable<Awaited<ReturnType<typeof getClientReports>>>
export type GetClientReportsQueryError = ErrorType<unknown>


export function useGetClientReports<TData = Awaited<ReturnType<typeof getClientReports>>, TError = ErrorType<unknown>>(
 userId: string,
    clientId: number,
    params: undefined |  GetClientReportsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getClientReports>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClientReports>>,
          TError,
          Awaited<ReturnType<typeof getClientReports>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetClientReports<TData = Awaited<ReturnType<typeof getClientReports>>, TError = ErrorType<unknown>>(
 userId: string,
    clientId: number,
    params?: GetClientReportsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getClientReports>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClientReports>>,
          TError,
          Awaited<ReturnType<typeof getClientReports>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetClientReports<TData = Awaited<ReturnType<typeof getClientReports>>, TError = ErrorType<unknown>>(
 userId: string,
    clientId: number,
    params?: GetClientReportsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getClientReports>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get client product reports
 */

export function useGetClientReports<TData = Awaited<ReturnType<typeof getClientReports>>, TError = ErrorType<unknown>>(
 userId: string,
    clientId: number,
    params?: GetClientReportsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getClientReports>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetClientReportsQueryOptions(userId,clientId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






